import React from 'react';
import { CheckCircle, Users, UserPlus, Compass } from 'lucide-react';
import { StepProps } from '../../types/onboarding';
import { Button } from '../ui/button';
import { useOnboarding } from '../../contexts/OnboardingContext';

export const WelcomeStep: React.FC<StepProps> = ({ onNext }) => {
  const { dismissOnboarding } = useOnboarding();

  return (
    <div className="text-center py-8">
      <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">
        Welcome to WorkOrder HQ! 🎉
      </h2>
      <p className="text-lg text-gray-600 dark:text-gray-400 mb-8">
        Let's get your workspace set up in just a few steps. This will only take 5 minutes.
      </p>

      <div className="my-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
            <CheckCircle className="text-green-500 mb-3 mx-auto" size={32} />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              1. Add Your First Client
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Create a client and their primary location
            </p>
          </div>
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
            <Users className="text-blue-500 mb-3 mx-auto" size={32} />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              2. Add Vendors
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Add vendors you work with (optional)
            </p>
          </div>
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
            <UserPlus className="text-purple-500 mb-3 mx-auto" size={32} />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              3. Invite Your Team
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Add team members to collaborate (optional)
            </p>
          </div>
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-6">
            <Compass className="text-orange-500 mb-3 mx-auto" size={32} />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
              4. Quick Tour
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              Learn about key features
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-between items-center mt-8">
        <Button
          variant="outline"
          onClick={dismissOnboarding}
          className="px-6"
        >
          Skip Setup
        </Button>
        <Button
          onClick={onNext}
          className="px-6"
        >
          Get Started →
        </Button>
      </div>
    </div>
  );
};

